export default {
  chooseLanguage: 'Choose language',
  address: 'Visit us',
};
